module.exports = __webpack_public_path__ + "static/media/bshare-bnb-LP.9144444a.png";